<template>
	<div class="site-settings">
		<div class="site-settings__container">
			<div class="site-settings__inputs vx-row">
				<div class="vx-col w-full sm:w-1/2">
					<vs-input
						v-model="partner.emailPartner"
						v-validate="'required|min:3|email'"
						name="emailPartner"
						:label="$t('emailPartner')"
						class="site-settings__input w-full mb-4"
                        :readonly="mode === 'edit'"
					/>
					<span v-if="errors.first('emailPartner')" class="text-danger text-sm">
						{{ $t('fieldFilledIncorrect') }}
					</span>
				</div>
				<div class="vx-col w-full sm:w-1/2">
					<vs-input
                        v-if="mode === 'edit'"
						v-model="partner.partnerCreateAccount"
						name="partnerCreateAccount"
						:label="$t('partnerCreateAccount')"
						class="site-settings__input w-full mb-4"
                        readonly='true'
					/>
					<span v-if="errors.first('partnerCreateAccount')" class="text-danger text-sm">
						{{ $t('fieldFilledIncorrect') }}
					</span>
				</div>
            </div>
			<div class="site-settings__inputs vx-row">
				<div class="vx-col w-full sm:w-1/2 mb-4">
					<vs-input
						v-model="partner.partnerFirstName"
						v-validate="'min:2'"
						name="partnerFirstName"
						:label="$t('partnerFirstName')"
						class="site-settings__input w-full"
					/>
					<span v-if="errors.first('partnerFirstName')" class="text-danger text-sm">
						{{ $t('fieldFilledIncorrect') }}
					</span>
				</div>
				<div class="vx-col w-full sm:w-1/2 mb-4">
					<vs-input
						v-model="partner.partnerLastName"
						v-validate="'min:2'"
						name="partnerLastName"
						:label="$t('partnerLastName')"
						class="site-settings__input w-full"
					/>
					<span v-if="errors.first('partnerLastName')" class="text-danger text-sm">
						{{ $t('fieldFilledIncorrect') }}
					</span>
				</div>
            </div>
            <hr class="w-full mb-4 mt-4">
			<div class="site-settings__inputs vx-row">
				<div class="vx-col w-full sm:w-1/2 mb-4">
					<vs-input
						v-model="partner.passPartner1"
						v-validate="'min:6|max:32'"
						name="passPartner1"
						:label="$t('passPartner1')"
						class="site-settings__input w-full"
					/>
					<span v-if="errors.first('passPartner1')" class="text-danger text-sm">
						{{ $t('fieldFilledIncorrect') }}
					</span>
				</div>
				<div class="vx-col w-full sm:w-1/2 mb-4">
					<vs-input
						v-model="partner.passPartner2"
						v-validate="'min:6|max:32'"
						name="passPartner2"
						:label="$t('passPartner2')"
						class="site-settings__input w-full"
					/>
					<span v-if="errors.first('passPartner2')" class="text-danger text-sm">
						{{ $t('fieldFilledIncorrect') }}
					</span>
				</div>
            </div>
            <hr class="w-full mb-4 mt-4">
            <div class="site-settings__inputs vx-row">
                <div
                    v-for="(site, siteIndex) in partner.listWeb"
                    :key="`siteIndex=${siteIndex}`"
                    class="vx-col w-full sm:w-1/3 mt-4 mb-4"
                >
                    <vs-checkbox
                        v-model="site.isPartnerWebsite"
                        class="w-full"
                    >{{ site.websiteDomain }}</vs-checkbox>
                </div>
            </div>
        </div>
        <hr class="w-full mt-2">
        <div class="site-edit-item__controls vx-row mt-3 flex justify-end">
            <div class="vx-col mt-2">
                <vs-button
                    v-if="$store.state.auth.role === 'admin'"
                    @click="save"
                >{{ $t('save') }}</vs-button>
            </div>
            <div class="vx-col mt-2">
                <vs-custom-button
                    @click="$router.back()"
                    type="border"
                    color="warning"
                >{{ $t('cancel') }}</vs-custom-button>
            </div>
        </div>

    </div>
</template>

<script>
    import databaseManager from "@/mixins/databaseManager";
    import notifier from "@/mixins/notifier";

    export default {
        name: "PartnerItem",
        mixins: [databaseManager, notifier],
        data() {
            return {
                partner: {},
            };
        },
        computed: {
            mode() {
                return this.$route.params.mode;
            },
            partnerId() {
                return this.$route.params.id;
            }
        },
        methods: {
	    	async updatePartner() {
                try {
				    this.partner = await this.dbViewPartner(this.partnerId);
                } catch(e) {
                    this.notifyError(e.message);
                }
            },
            async fillPartner() {
                this.partner = {
                    emailPartner: "",
                    partnerCreateAccount: "",
                    id: 0,
                    partnerFirstName: "",
                    partnerLastName: "",
                    passPartner1: "",
                    passPartner2: "",
                    listWeb: []
                };

                try {
				    this.partner.listWeb = await this.dbViewPartnerWebsites();
                } catch(e) {
                    this.notifyError(e.message);
                }
            },
            async save() {
                this.validate = true;
                try {
                    const data = Object.assign({}, this.partner);

                    if(this.mode === "edit") {
                        await this.dbUpdatePartner(this.partner.id, data);
                        this.notifySuccess(this.$t('changesIsSavedSuccessfully'));
                    } else if(this.mode === "create") {
                        await this.dbCreatePartner(data);
                        this.notifySuccess(this.$t('partnerWasCreatedSuccessfully'));
                    }

                    this.$router.back();

                } catch(e) {
                    this.notifyError(e.message);
                }
            },
        },
        async mounted() {
            try {
                if(this.mode === "edit") {
                    await this.updatePartner();
                } else if(this.mode === "create") {
                    this.fillPartner();
                }
            } catch(e) {
                this.notifyError(e.message);
            }
        },
    }

</script>

<style lang="scss" scoped>

</style>